<!-- 个人消息 -->
<template>
  <div class="personal-message">
    <div>
      <h1>全部消息</h1>
      <Form ref="formValidate"
            :model="formValidate">
        <div class="personal-message-sel">
          <FormItem label="类型筛选">
            <Select v-model="formValidate.type"
                    placeholder="Select"
                    clearable>
              <Option v-for="(item, index) in messageTypeMap"
                      :key="index"
                      :value="item.value">{{item.title}}</Option>
            </Select>
          </FormItem>
        </div>
        <div class="personal-message-sel">
          <FormItem label="时间筛选">
            <DatePicker type="datetimerange"
                        placeholder="Select date"
                        format="yyyy-MM-dd"
                        @on-change="changeTime"></DatePicker>
          </FormItem>
        </div>
        <div class="personal-message-btn">
          <Button class="zlr-btn-default"
                  @click="handleSearch">查询</Button>
        </div>
        <div class="personal-message-tab-btn">
          <Button class="zlr-btn-default"
                  @click="handleAllRead">全部标为已读</Button>
        </div>
      </Form>
      <ul class="personal-message-list"
          v-if="list.length">
        <li v-for="(item, index) in list"
            :key="index">
          <div class="personal-message-list-left">
            <img :src="item.source === 'MENTOR'?item.headPortrait:msp"
                 alt="头像">
          </div>
          <div class="personal-message-list-right">
            <div class="personal-message-list-intro">
              <div> {{item.source === 'MENTOR'? item.mentorType+'导师': 'MSP'}} <span>在</span><span style="color: #6589dd;text-decoration: underline;">{{item.type==="LESSON_SCHEDULE"?'课程提醒':''}}</span>
                <remind-link :data="item"></remind-link>
              </div>
              <a v-if="item.readStatus==='UN_READ'"
                 @click="handleRead(item)">标为已读</a>
            </div>
            <p>{{item.messageContent}}</p>
            <div class="personal-message-list-time">
              {{item.createTime}}
            </div>
          </div>
        </li>
      </ul>
      <zlr-empty v-else></zlr-empty>
      <div class="personal-message-page"
           v-if="list.length">
        <Page :total="totalItems"
              :page-size="pageSize"
              :current="currentPage"
              @on-change="handlePageChange"></Page>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { getMessagePage, subMessageRead, subMessageReadAll } from '@/api/message'
// images
import msp from '@/assets/msp.svg'
// mixins
import mixinsPage from '@/view/mixins/page'
// components
import RemindLink from '_c/remind/remind-link'
import ZlrEmpty from '_c/empty/empty'
// constant
import { messageTypeMap } from '@/constant'
export default {
  name: 'personal-message',
  mixins: [mixinsPage],
  components: {
    RemindLink,
    ZlrEmpty
  },
  data () {
    return {
      messageTypeMap,
      msp,
      formValidate: {
        createTimeStart: '',
        createTimeEnd: ''
      },
      list: []
    }
  },
  computed: {},
  mounted () {
    this.getPageList()
  },
  methods: {
    getPageList () {
      let data = {
        ...this.formValidate,
        currentPage: this.currentPage - 1,
        pageSize: this.pageSize
      }
      getMessagePage(data).then(res => {
        let page = res.data.page
        this.list = page.result
        this.totalItems = page.totalItems
      }).catch(() => {
        this.list = []
        this.totalItems = 0
      })
    },
    changeTime (data) {
      this.formValidate.createTimeStart = data[0]
      this.formValidate.createTimeEnd = data[1]
    },
    // 标记为已读
    handleRead ({ msgId }) {
      subMessageRead({
        msgId
      }).then(() => {
        this.$Message.success('标记成功')
        this.getPageList()
      })
    },
    // 标记所有为已读
    handleAllRead () {
      subMessageReadAll({}).then(() => {
        this.$Message.success('标记成功')
        this.getPageList()
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
<style lang="less">
.personal-message {
  .ivu-picker-confirm-time {
    display: none;
  }
}
</style>
